import React, { PropsWithChildren } from 'react'
import ReactDOM from 'react-dom'
import { Component } from 'react'
import { IMultiSelectPortalProps } from '../multi-select/interfaces'
import { getRandId } from '@pushly/models/lib/utils/get-rand-id'

const preventBubbling = (event: MouseEvent | any): void => {
    if (event) {
        event.stopPropagation()
    }
}

export class BetterSelectPortal extends Component<PropsWithChildren<IMultiSelectPortalProps>, {}> {
    private portalElement: any
    private defaultClassNames: string[] = ['better-select', 'bsl-dropdown-container']

    /**
     * Render method creates the actual portal when {@link this.portalElement} exists
     *
     * ReactDOM.createPortal takes:
     * 1. The content to render (this.props.children)
     * 2. The DOM node to render it into (this.portalElement)
     *
     * Returns null if the target element doesn't exist yet
     */
    public render() {
        return this.portalElement ? ReactDOM.createPortal(this.props.children, this.portalElement) : null
    }

    public componentDidMount() {
        let p: any = this.props.portalId && document.getElementById(this.props.portalId)

        if (!p) {
            p = document.createElement('div')
            p.id = this.props.portalId
            p.key = getRandId('bsl-portal-')

            this.buildClassNames().forEach((className) => p.classList.add(className))

            this.props.container.appendChild(p)
        }

        this.portalElement = p
        this.portalElement.addEventListener('mousedown', preventBubbling)

        // Force a re-render to create the portal
        this.forceUpdate()
    }

    public componentWillUnmount() {
        this.portalElement.removeEventListener('mousedown', preventBubbling)

        // Only remove if it's a child of the container
        if (this.portalElement && this.portalElement.parentNode === this.props.container) {
            this.props.container.removeChild(this.portalElement)
        }
    }

    public componentDidUpdate(): void {
        if (!!this.portalElement.classList && this.portalElement.classList.length > 0) {
            this.portalElement.classList.remove(...this.portalElement.classList)
        }
        this.buildClassNames().forEach((className) => this.portalElement.classList.add(className))

        // Note: We don't need to manually update portal content
        // React's reconciliation will automatically update the portal content
        // because it's returned from render()
    }

    private buildClassNames(): string[] {
        const classNames = [...this.defaultClassNames]

        if (this.props.className) {
            this.props.className.split(' ').forEach((className) => classNames.push(className.trim()))
        }

        return classNames
    }
}
